import axios from 'axios'; 

import apiSettings from '../config/apiSettings';
import { getAuthorizationHeader } from '../utils/auth';
import IReportUserRequest from '../types/support/IReportUserRequest';
import IResyncUserRequest from '../types/support/IResyncUserRequest';

export default {
	getReportUser: (model: IReportUserRequest, accessToken: string) => axios.post(apiSettings.baseUrl + '/api/ReportUser', model, { headers: getAuthorizationHeader(accessToken) }),
	resyncUser: (model: IResyncUserRequest, accessToken: string) => axios.post(apiSettings.baseUrl + '/api/ResyncUser', model, { headers: getAuthorizationHeader(accessToken) }),
}
